<template>
    <div class="home">

        <img :src="`${img}t.png`" alt="" style="width: 100%" />

        <Right :tel="tel" :img="img" @rule="rule" />

        <div class="component">
            <Hlb2 :btnHeight="60" :btnWidth="280" :checkbox-color="ckColor" @flagx="flagx" @keys="keys"
                @env-change="getEnv" ref="comp" :productCode="productCode" :a="a" :img="img" :btnimg="btnimg"
                @rule="rule" @ys="ys" :agree="agree" :color="colors" />
            <img :src="`${img}b.png`" alt="" style="width: 100%" />
            <Bottom :text="text" :color="colors" class="bottom" />
            <Rulex :show="show" :show1="show1" :title="title" :contentx="contentx" :content="content" :title1="title1"
                @close1="close1" @close="close" />

        </div>
    </div>
</template>

<script>
import { userApi, traceApi } from '@/api/index.js'  // 导入命名导出
import Hlb2 from "@/components/Hlb2.vue";
import Bottom from "@/components/Bottom.vue";
import Right from "@/components/Right.vue";
import Rulex from "@/components/Rulex.vue";

export default {
    name: "XW",
    components: {
        Hlb2,
        Bottom,
        Right,
        Rulex,


    },
    data() {
        return {
            ckColor: '#fff',//勾选框颜色
            key1: {},
            env: '',
            productCode: 'LH2767',
            a: "",
            flag: false,
            title1: '隐私保护指引》',
            show1: false,
            title: "产品说明",
            show: false,
            colors: 'color:#fff',//底部颜色和协议颜色
            agree: [

                {
                    name: '我已同意并阅读',
                    id: 0,
                    url: ""
                },
                {
                    name: '《隐私保护指引》',
                    id: 1,
                    url: ""
                },
                {
                    name: '《会员服务协议》',
                    id: 2,
                    url: "https://web.78keji.cn/qbxy/"
                },

                {
                    name: '《通联支付快捷支付服务协议》',
                    id: 4,
                    url: "https://qb.78keji.cn/tl_agreement"
                },
                {
                    name: '《小悟用户协议》',
                    id: 5,
                    url: "https://qiwu.ai/app/user/hudongStory2/?type=1#/"
                },
                {
                    name: '《小悟隐私协议》',
                    id: 6,
                    url: "https://qiwu.ai/app/user/hudongStory2/?type=2#/"

                },
                {
                    name: '《小悟自动续费协议》',
                    id: 7,
                    url: "https://xiaowu.centaurstech.com/static/protocolManage.html?title=199&channelId=XIAOWU"
                },
                {
                    name: '《产品说明》',
                    id: 3,
                    url: ""
                }

            ],
            img: "https://qb.78keji.cn/image/xw/hlb/2735/",
            btnimg: "https://qb.78keji.cn/image/xw/hlb/2735/btn.png",
            tel: '4001380908',
            text: [
                "业务资费：首日0元，续订39.9元/月（随时取消）",
                "续订权益：小悟故事会员月卡、30元支付宝立减金、省心APP会员权益",
                "客服热线：400-1380-908",
            ],
            contentx: [
 "  1、活动时间：2025.12.01-2026.12.31",

"2、产品名称：【小悟故事+省心】联合会员",

"3、客服咨询：400-1380-908（工作日8:00-22:00）",

"4、活动对象：通过正常通道进入活动且未参与过该活动的用户均可参与。（限购1单）",

"5、产品资费：本产品在您完成订阅操作后可享首次免费体验，体验期内如您未取消订阅，我们将在体验期结束后自动为您扣费升级成为正式会员，续费39.9元/月，您可随时取消该订阅。扣费采用签约代扣的方式进行收费，会在每一个计费周期到期前24小时，自动从您的账户中扣费（请确保余额充足）。如对产品有异议或者建议等，请联系客服登记处理。",

"6、权益说明：",
"（1）体验会员包含1张5元支付宝通用立减金，1张小悟故事会员1天卡。",
"（2）正式会员包含6张5元支付宝通用立减金，1张小悟故事会员月卡,1张百川短剧会员月卡，省心App100元购物金、省心App购物优惠（可用于省心App内使用）。",
"注：小悟故事和百川短剧vip会员月卡在您领取后默认充值到您订购时的手机号对应注册的小悟故事和百川短剧账号下；支付宝通用立减金可用于线上线下任意支付宝支付场景，使用支付宝支付，且金额大于5元，使用银行卡付款时均可自动抵扣。",

"7、权益领取：",
"（1）体验会员权益直接发放至用户办理手机对应的支付宝账号和小悟故事账号上；",
"（2）正式会员包括1张小悟故事vip会员月卡+1张百川短剧会员月卡+6张5元支付宝通用立减金（共计30元）+省心App100元购物金、省心App购物优惠（可用于省心App内使用）。",
"①1张小悟故事会员vip月卡，领取后默认充值到订购时的手机号对应注册的小悟故事账号下。",
"②1张百川短剧会员vip月卡，领取后默认充值到订购时的手机号对应注册的百川短剧账号下。",
"③6张5元支付宝通用立减金，请前往微信小程序【省心智生活】领取您的立减金。领取规则为：订阅期内微信搜索关注【省心智生活】小程序->登录办理联合会员手机号->我的->权益兑换->选择小悟故事合会员领取权益->选择立减金领取即可（领取详情见阅短信）。领取规则为：订阅期内每5天可领取一张，每月共可领取6张，过期不可再领取，每张立减金限领取后24小时内使用（支付宝立减金领取后将发放到您订购时填写的手机号注册的支付宝账户-卡包。该产品为虚拟商品请填写正确手机号）",
"④省心App100元购物金",
"A.省心购物金是 app 为会员专属打造的 “无门槛消费抵扣金”，可直接用于商城购物付款抵扣、无需复杂计算，到账即能用，是会员 “省心省钱” 的核心福利之一，与消费返利、优惠券形成三重省钱 buff。",
"B.每月自动下发的100元购物金仅支持当月(30天内)使用，过期失效。",
"C.使用范围：为省心App内选择淘宝商品购物使用。无品类限制、无最低消费门槛，付款时直接勾选抵扣；可叠加使用：支持与优惠券、消费返利同时使用，付款时系统自动计算最优抵扣方案，不用手动搭配，省心最大化。",
"D.使用规则：在购买淘宝商品是会计算出可使用的购物金金额。用户从商品列表或商品页面进入可查看对应到购物金抵扣的金额，点击立即购跳转淘宝后自动加入购物金红包，点击立即领取后跳转至淘宝商品详情页面进行购买（购买时可查看到使用的购物金红包）",
"⑤省心会员",
"A.省心会员适用于省心app内隐藏优惠券和购物佣金翻倍奖励",
"B.省心会员均享受 “基础权益 + 专属权益” 双重内容。如消费返利、专属折扣、跨界权益联动、专属活动资格、专属客服等专属内容",
"C.会员专属内容：从购物优惠到生活服务，承包你的全方位需求。省心app内淘宝、京东、拼多多、唯品会、小米有品、美团饿了么、淘票票、团油等平台的购物都有专属权益",

"8. 取消订阅/续订：如需解约本产品，请前往微信小程序“省心智生活”-点击“我的订单”-选择小悟故事联合会员-点击侧边文字“退订服务”进行申请解绑。",

"9、退费说明：联合产品属于虚拟类产品，非预付卡，不适用无理由退货，开通成功后，联合产品权益不可转让。如有任何问题请联系客服：400-1380-908（工作日8:00-22:00）。",

"10、严禁以任何形式翻录或转载、未经许可在第三方平台传播，违者将追究法律责任。",

"11、您在购买自动续费服务后，将会在到期前1天为您发起续费，自动延长一个月联合会员权益；您可随时在支付宝-支付设置内取消，取消后则不再发起续费，在小悟故事与第三方合作发生变更或终止时，您的订购服务将自动解约，以届时实际通知为准。",

"12、特别提醒",
"（1）购买本联合产品，应同时遵守小悟故事和省心产品各自发布的《用户服务协议》、《隐私权政策》、《会员服务协议》（统称“平台规则”），如违反任一平台规则，省心产品和小悟故事任何一方均有权单独按照其平台规则的规定进行处理，包括但不限于中止或终止提供其所属平台的服务及要求侵权赔偿等。故在开通前，请仔细阅读两个平台的规则。",
"（2）用户信息保护：为您领取权益目的，小悟故事和省心产品会收集使用您的相关信息。当您购买联合产品并手动勾选相关服务协议后，表明您接受并同意收集使用您的个人信息。活动主办方使用个人信息仅限于购买、领取、使用联合产品所需，并在合理范围内予以保护，详细个人信息政策请阅小悟故事和省心产品《隐私权政策》及《用户服务协议》。如您不同意请不要参与本次活动。",
"（3）互联网存在诸多不确定性因素，因此理解并同意，如因不可抗力、网络、通讯线路故障、计算机大规模瘫痪及活动中存在大面积作弊行为等非小悟故事原因致使本活动出现异常情况或难以继续开展的，活动主办方有权采取包括但不限于通过各种方式消除异常情况或调整、暂停、取消本活动等措施，因此造成用户损失的，小悟故事不承担责任。",
"（4）如出现不可抗力或情势变更的情况（包括但不限于重大灾害事件，活动受政府机关指令需要停止举办或调整的，活动遭受严重网络攻击或因系统故障导致包括但不限于活动中断、停办、权益领取和使用出现问题），活动主办方可依据相关法律法规的规定主张免责，主办方拥有取消本次活动的权利。",
"（5）在法律规定的范围内，小悟故事有权对活动规则进行解释，并根据活动的实际情况对本活动的规则进行变动或调整，相关变动或调整将公布在本活动规则页面，公布后依法生效。",
"（6）如果用户出现违规行为（如作弊领取、恶意套现、刷取信誉、虚假交易、以所获得权益进行盈利、不当使用、倒买倒卖等违背诚实信用的行为），活动主办方将取消收回全部权益（含已使用的及未使用的），必要时追究法律责任。",
            ],
            content: [
                "用户协议",
                "尊敬的用户，欢迎使用由成都启奔科技有限公司（下列简称为“启奔科技”）提供的服务。在使用前请您阅读如下服务协议，使用本应用即表示您同意接受本协议，本协议产生法律效力，特别涉及免除或者限制启奔科技责任的条款，请仔细阅读。如有任何问题，可向启奔科技咨询。",
                "1. 服务条款的确认和接受",
                "通过访问或使用本应用，表示用户同意接受本协议的所有条件和条款。",
                "2. 服务条款的变更和修改",
                "启奔科技有权在必要时修改服务条款，服务条款一旦发生变更，将会在重要页面上提示修改内容。如果不同意所改动的内容，用户可以放弃获得的本应用信息服务。如果用户继续享用本应用的信息服务，则视为接受服务条款的变更。本应用保留随时修改或中断服务而不需要通知用户的权利。本应用行使修改或中断服务的权利，不需对用户或第三方负责。",
                "3. 用户行为",
                "3.1 用户账号、密码和安全",
                "您需注册登录账号方可使用我司产品功能。",
                "3.2 账号注册时的禁止行为",
                "（1）请勿以党和国家领导人或其他社会名人的真实姓名、字号、艺名、笔名注册；",
                "（2）冒充任何人或机构，或以虚伪不实的方式谎称或使人误认为与任何人或任何机构有关的名称；",
                "（3）请勿注册和其他网友之名相近、相仿的名字；",
                "（4）请勿注册不文明、不健康名字，或包含歧视、侮辱、猥亵类词语的名字；",
                "（5）请勿注册易产生歧义、引起他人误解的名字；",
                "3.3 用户在本应用上不得发布下列违法信息和照片：",
                "（1）反对宪法所确定的基本原则的；",
                "（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；",
                "（3）损害国家荣誉和利益的；",
                "（4）煽动民族仇恨、民族歧视，破坏民族团结的；",
                "（5）破坏国家宗教政策，宣扬邪教和封建迷信的；",
                "（6）散布谣言，扰乱社会秩序，破坏社会稳定的；",
                "（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；",
                "（8）侮辱或者诽谤他人，侵害他人合法权益的；",
                "（9）含有法律、行政法规禁止的其他内容的；",
                "（10）禁止骚扰、毁谤、威胁、仿冒网站其他用户；",
                "（11）严禁煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；",
                "（12）严禁发布可能会妨害第三方权益的文件或者信息，例如（包括但不限于）：病毒代码、黑客程序、软件破解注册信息。",
                "（13）禁止上传他人作品。其中包括你从互联网上下载、截图或收集的他人的作品；",
                "（14）禁止上传广告、横幅、标志等网络图片；",
                "4. 服务内容",
                "本服务的具体内容由启奔科技根据实际情况提供，启奔科技可以对其提供的服务予以变更，且启奔科技提供的服务内容可能随时变更。",
                "",
                "隐私条款",
                "1.用户信息公开情况说明",
                "尊重用户个人隐私是启奔科技的一项基本政策。所以，启奔科技不会在未经合法用户授权时公开、编辑或透露其注册资料及保存在本应用中的非公开内容，除非有下列情况：",
                "（1）有关法律规定或启奔科技合法服务程序规定；",
                "（2）在紧急情况下，为维护用户及公众的权益；",
                "（3）为维护启奔科技的商标权、专利权及其他任何合法权益；",
                "（4）其他需要公开、编辑或透露个人信息的情况；",
                "在以下（包括但不限于）几种情况下，启奔科技有权使用用户的个人信息：",
                "（1）在进行促销或抽奖时，启奔科技可能会与赞助商共享用户的个人信息，在这些情况下启奔科技会在发送用户信息之前进行提示，并且用户可以通过不参与来终止传送过程；",
                "（2）启奔科技可以将用户信息与第三方数据匹配；",
                "（3）启奔科技会通过透露合计用户统计数据，向未来的合作伙伴、广告商及其他第三方以及为了其他合法目的而描述启奔科技的服务；",
                "2.隐私权政策适用范围",
                "（1）用户在使用本应用服务器时留下的个人身份信息；",
                "（2）用户通过本应用服务器与其他用户或非用户之间传送的各种资讯；",
                "（3）本应用与商业伙伴共享的其他用户或非用户的各种信息；",
                "（4）启奔科技软件十分注重保护用户的个人隐私，并制定了《隐私政策》，用户亦可以通过《隐私政策》，用户确认并同意使用启奔科技软件提供的服务将被视为接受《隐私政策》。",
                "3.资讯公开与共享",
                "启奔科技不会将用户的个人信息和资讯故意透露、出租或出售给任何第三方。但以下情况除外：",
                "（1）用户本人同意与第三方共享信息和资讯;",
                "（2）只有透露用户的个人信息和资讯，才能提供用户所要求的某种产品和服务;",
                "（3）应代表本应用提供产品或服务的主体的要求提供（除非我们另行通知，否则该等主体无权将相关用户个人信息和资讯用于提供产品和服务之外的其他用途）：根据法律法规或行政命令的要求提供;因外部审计需要而提供;用户违反了本应用服务条款或任何其他产品及服务的使用规定;经本站评估，用户的帐户存在风险，需要加以保护。",
                "4.非个人隐私信息",
                "为了改善启奔科技软件的技术和服务，向用户提供更好的服务体验，启奔科技或可会自行收集使用或向第三方提供用户的非个人隐私信息。",
                "5.如何联系我们",
                "您可以通过以下方式与我们联系，我们将在15天内回复您的请求：",
                "（1）如对本政策内容、个人信息有任何疑问、意见或建议，您可通过启奔科技客服邮箱：【912716425@qq.com】与我们联系。",
                "（2）如发现个人信息可能被泄露，您可以联系我们的客服人员进行投诉举报；",
                "如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。",
            ],


        };
    },
    methods: {
        keys(e) {


            console.log(e, '获取的keys')
            this.key1 = e

        },
        getEnv(e) {

            this.env = e
        },
        sure() {
            console.log('点击确定')
            this.$refs.comp.pay();
        },
        point(e, n) {
            traceApi.event({
                t: localStorage.getItem('traceId'),
                e: e,
                f: n
            }).then((res) => {

            })
        },
        loadScript(src) {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = src;
                script.onload = resolve;
                script.onerror = () => reject(new Error(`Script load failed: ${src}`));
                document.head.appendChild(script);
            });
        },
        init() {
            console.log(this.$route.query)
            if (this.$route.query.a) {
                this.a = this.$route.query.a
                this.generateUUID()//获取uuid
                traceApi.click({
                    c: this.a,
                    p: this.productCode,
                    t: localStorage.getItem('traceId'),
                    directUrl: document.referrer,//直接请求地址
                    indirectUrl: ""	//间接请求地址
                }).then((res) => {

                    if (localStorage.getItem('mobile')) {
                        traceApi.event({
                            t: localStorage.getItem('traceId'),
                            e: 4,
                            obj: localStorage.getItem('mobile')
                        })
                    }
                    userApi.prepare({
                        channelCode: this.a,
                        productCode: this.productCode,
                        traceId: localStorage.getItem('traceId')
                    }).then((res) => {
                        console.log(res)
                    })
                }).catch((err) => {
                    if (localStorage.getItem('mobile')) {
                        traceApi.event({
                            t: localStorage.getItem('traceId'),
                            e: 4,
                            obj: localStorage.getItem('mobile')
                        })
                    }
                    userApi.prepare({
                        channelCode: this.a,
                        productCode: this.productCode,
                        traceId: localStorage.getItem('traceId')
                    }).then((res) => {
                        console.log(res)
                    })
                })
            } else {
                this.$router.push({
                    path: '/404'
                })
            }
        },
        generateUUID() {
            // 使用更可靠的方法
            const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });

            // 移除所有横杠，取前26位
            const traceId = uuid.replace(/-/g, '').substring(0, 26);

            localStorage.setItem('traceId', traceId);
            return traceId;
        },
        cflag() {
            this.flag = false
        },
        flagx(e) {
            this.flag = e
        },
        ys(e) {
            this.show1 = e
        },
        rule(e) {
            this.point(6)
            this.show = e
        },
        close1(e) {
            this.show1 = e
        },
        close(e) {
            this.show = e
        }
    },
    // 1. 组件初始化阶段
    beforeCreate() {
        console.log(
            "1. [beforeCreate]: 实例初始化之后，data 和 methods 还未被创建。"
        );
        // 此时访问 this.count 会是 undefined
    },

    created() {
        if (this.$route.query.debug) {
            this.loadScript('https://pagespy.zzqz2024.com/page-spy/index.min.js')
                .then(() => {
                    console.log('调试 SDK 加载完成');
                });
            this.loadScript('https://pagespy.zzqz2024.com/plugin/data-harbor/index.min.js')
                .then(() => {
                    console.log('调试 SDK 加载完成');
                });
            this.loadScript('https://pagespy.zzqz2024.com/plugin/rrweb/index.min.js')
                .then(() => {
                    console.log('调试 SDK 加载完成');
                });
            setTimeout(() => {
                window.$harbor = new DataHarborPlugin();
                window.$rrweb = new RRWebPlugin();

                [window.$harbor, window.$rrweb].forEach(p => {
                    PageSpy.registerPlugin(p)
                })

                window.$pageSpy = new PageSpy({
                    api: "pagespy.zzqz2024.com",
                    clientOrigin: "https://pagespy.zzqz2024.com/",
                    project: localStorage.getItem('traceId'),
                    autoRender: false,
                    title: window.location.href,
                });
                this.init()
            }, 1000)
        } else {
            this.init()
        }
    },
    // // 2. DOM挂载阶段
    // beforeMount() {
    //   console.log(
    //     "3. [beforeMount]: 模板编译完成，但尚未将虚拟DOM挂载到真实页面。"
    //   );
    //   // 此时访问 this.$el 会是 undefined (尚未挂载)
    // },

    // mounted() {
    //   console.log("4. [mounted]: 实例已挂载到DOM，可以安全地访问 this.$el 了。");
    //   console.log("   - 挂载的元素是:", this.$el);
    //   // 适合在此处操作DOM、使用第三方库初始化、设置定时器等
    // },

    // // 3. 更新阶段 (当数据变化时)
    // beforeUpdate() {
    //   console.log("5. [beforeUpdate]: 数据更新时，虚拟DOM重新渲染和打补丁之前。");
    //   console.log(`   - 数据即将从 ${this.previousCount} 变为 ${this.count}`);
    // },

    // updated() {
    //   console.log("6. [updated]: 数据更新后，虚拟DOM已重新渲染并完成打补丁。");
    //   console.log(`   - 数据更新已完成，当前计数是: ${this.count}`);
    //   // 注意：避免在此钩子中更改状态，可能导致无限循环。
    // },

    // // 4. 销毁阶段
    // beforeDestroy() {
    //   console.log("7. [beforeDestroy]: 实例销毁之前，组件仍完全可用。");
    //   // **重要**：在此处进行清理工作，如清除定时器、取消事件监听、取消未完成的异步请求等。

    //   console.log("   - 定时器已清理。");
    // },

    // destroyed() {
    //   console.log("8. [destroyed]: 实例销毁后，所有指令解绑，事件监听器被移除。");
    // },
};
</script>
<style scoped>
.home {
    background: #fedcb7;
    min-height: 100%
}

.component {
    margin-top: -70px;
}

.bottom {
    margin-top: 15px;
}
</style>
